import {connect} from 'react-redux';
import React, {Component} from 'react';

import Map from '../Base/Map';
import Layout from '../Base/Layout';
import ObjectPreview from '../Base/PropertyPreview';
import {setLastObjects} from '../../actions/Home';

const defaultProps = {
    setLastObjects: () => {
    }
};

class HomePage extends Component {
    componentDidMount() {
        this.props.setLastObjects();
    }

    render() {
        const i18n = this.props.i18n;

        return (
            <Layout
                title={i18n['home.document.title'] !== undefined ? i18n['home.document.title'] : ''}
                showPromoContent={true}
            >
                <section className="last">
                    <h2>{i18n['home.lastObjects']}</h2>
                    <div className="section-content">
                        {this.props.lastObjects.slice(0, 4).map(object =>
                            <ObjectPreview key={object.id} object={object} />
                        )}
                    </div>
                </section>

                {this.props.isGoogleApiInit && this.props.defaultLat !== undefined &&
                <Map id="map" objects={this.props.lastObjects} zoom={10} />}
            </Layout>
        )
    }
}

HomePage.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    lastObjects: state.homePage.lastObjects,
    defaultLat: state.configuration.main.defaultLat,
    isGoogleApiInit: state.configuration.isGoogleApiInit
});

const mapDispatchToProps = {
    setLastObjects
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/Home/HomePage.js